export default "__VITE_ASSET__DlpSVzDo__"